import React, {useState, useContext, useEffect} from 'react';
import { CircularProgress, Avatar, Button, CssBaseline, TextField, Link, Box, Typography, Container } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import bg_image from '../asset/pictures/adventist-symbol-tm--white.png';
import { API } from '../conf';
import { Context } from '../App';
import { Buffer } from 'buffer';
import { useParams, useNavigate } from 'react-router-dom';

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="http://www.feam.org/">FEAM</Link>
        {` ${new Date().getFullYear()}.`}
        </Typography>
    );
}


export default function MdpForm() {
    const { token } = useParams()
    const navigate = useNavigate()
    const [loading, setLoad] = useState(true)
    const [msg, setMsg] = useState()
    const [isExpired, setExpired] = useState(false)

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const mdp1 = data.get('password')
        const mdp2 = data.get('password-confirmation')

        if (mdp1===mdp2&&mdp1.length>=6) {
            setLoad(true)
            fetch(API.concat('/users/set-pwd'), {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + Buffer.from(token+':'+mdp1, 'utf-8').toString('base64'),
                },
            }).then(async(response)=> {
                if(response.status === 401) {
                    setMsg('Oups, ce lien est arrivé à expiration'); setLoad(false)
                }else if (response.status === 200) {
                    navigate('/login') 
                }else{
                    setMsg("Erreur! impossible d'enregistrer le nouveau mot de passe\n veuillez réessayer ultérieurement ou contacter votre administrateur.")
                    setLoad(false)
                }
            })
        } else setMsg(mdp1!==mdp2 ? 'Attention! les mots de passe sont différents.' : 'Mot de passe trop court.\n Le mot de passe doit contenir 6 caractères minimums.')
    };

    useEffect(()=>{
        fetch(API.concat('/check_token'), {method:'HEAD', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }}).then(response=>{
            setExpired(response.status!==200)
            setLoad(false)
        })
    }, [])

  return (
    <Box display='flex' flex={1} flexDirection='column' justifyContent='center' alignItems='center'>
        <div style={{display:'flex', width:"60%", height:"100vh", justifyContent:"center", alignItems:"center", flexDirection:'column'}}>
            <Typography variant='h3' align='center' marginTop={-25}>Thyba</Typography>
            <Typography variant='h6' align='center' marginTop={1}>Application de Trésorerie</Typography>
        
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                >
                    <Avatar sx={{ m: 1, bgcolor: '#255760' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Initialisation du mot de passe
                    </Typography>
                    <Typography color={'carmine.main'} align='center' sx={{whiteSpace:'pre-wrap'}}>{msg}</Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField required autoFocus fullWidth label="Mot de passe" name="password" type="password" autoComplete="new-password" sx={{marginBottom:3}}/>
                        <TextField required fullWidth  name="password-confirmation" label="Confirmation du mot de passe" type="password" />
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading} >
                            {loading&&<CircularProgress size={18} color='primary' style={{marginRight:7}}/>} Valider
                        </Button>
                    </Box>
                </Box>
            </Container>
            <div style={{position:'absolute', bottom:0, display:'flex', justifyContent:'center'}}><Copyright sx={{ mt: 8, mb: 4 }} style={{bottom:0}} /></div>
        </div>
    </Box>
  );
}